import cx from 'classnames';
import { PRODUCT_VARIANTS } from '../../../../../constants/commonConstants';
import PropTypes from 'prop-types';
import { Card, SaleIcon } from 'cat-ecommerce-alloy';
import ProductOverview from '../../ProductOverview';
import ProductCardThumbnail from '../ProductCardThumbnail';
import ProductPrimaryActions from '../../ProductPrimaryActions';
import styles from '../ProductCard.module.scss';
import { productShape } from '../../../../../hooks/useAnalytics/useAnalytics.proptypes';
import { useSelector } from 'react-redux';
import { PCC_RELEASE_HEADLESS_PDP_FLAG } from '@app/constants/featureFlags';

const ProductRelationCard = ({
  handleAddToCartError,
  itemCatEntryId,
  hasSpecial,
  imageUrl,
  gaListName,
  name,
  url,
  priceCallStatus,
  productId,
  productClickDetails,
  ...props
}) => {
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const isPDPHeadlessFeatureFlagEnable =
    useSelector(s => s.featureFlag?.[PCC_RELEASE_HEADLESS_PDP_FLAG]) ?? false;
  const itemNumber = name?.split(':') ?? [];

  const urlBasedonFeatureFlag = isPDPHeadlessFeatureFlagEnable
    ? `${esiteURL}/product/${itemNumber[0]}`
    : url;

  //Position static required for Popup to stand out of scroll div
  return (
    <Card className={cx('flex-row', 'position-static', styles['product-card'])}>
      <div className="me-2 pe-1 position-relative">
        {hasSpecial && (
          <SaleIcon className="u-fill-icon--CatYellow085 position-absolute" />
        )}
        <ProductCardThumbnail
          alt={name}
          className="d-block"
          height="96px"
          imageUrl={imageUrl}
          productClickDetails={productClickDetails}
          url={urlBasedonFeatureFlag}
          width="96px"
          gaListName={gaListName}
        />
      </div>
      <ProductOverview
        name={name}
        productId={productId}
        url={urlBasedonFeatureFlag}
        priceCallStatus={priceCallStatus}
        productClickDetails={productClickDetails}
        gaListName={gaListName}
        {...props}
      >
        <ProductPrimaryActions
          gaListName={gaListName}
          itemCatEntryId={itemCatEntryId}
          handleAddToCartError={handleAddToCartError}
          priceCallStatus={priceCallStatus}
          productClickDetails={productClickDetails}
          productId={productId}
          quantity={1}
          variant={PRODUCT_VARIANTS.card}
          url={urlBasedonFeatureFlag}
          partNumber={productId}
        />
      </ProductOverview>
    </Card>
  );
};

ProductRelationCard.propTypes = {
  gaListName: PropTypes.string,
  handleAddToCartError: PropTypes.func,
  hasSpecial: PropTypes.bool,
  itemCatEntryId: PropTypes.string,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  priceCallStatus: PropTypes.string.isRequired,
  productClickDetails: PropTypes.arrayOf(productShape),
  productId: PropTypes.string,
  url: PropTypes.string
};

export default ProductRelationCard;
